export { Paper } from "@mantine/core";
export type { PaperProps } from "@mantine/core";
export { getPaperOverrides } from "./Paper.styled";
